<template>

    <div>
        
        <div class="custom-page-title">
            <h3>
                Transportløsninger
            </h3>
        </div>

        <div class="container pd-50 products-wrapper">

            <div class="row">
                <div class="col-lg-3 col-md-3 col-xs-12">
                    
                    <div class="products-menu">
                        <h4>
                            Transportløsninger
                        </h4>

                        <p>
                            Læs om de forskellige transportløsninger vi tilbyder ved at klikke på nedenstående.
                        </p>

                        <hr>

                        <router-link :to="{path: '/transportloesninger/' + product.slug}"
                                     tag="a" v-for="product in products"
                                     v-bind:key="product.slug"
                        >
                            {{ product.name }}
                        </router-link>

                    </div>

                </div>

                <template>
                    <router-view></router-view>
                </template>

            </div>

        </div>

    </div>

</template>
<style lang="scss" scoped>
    .products-menu{
        background: #fff;
        padding: 20px;
        border-radius: 4px;
        box-shadow: 5px 5px 30px 0 rgba(0,0,0,.05);
        border: 1px solid #ddd;
        margin-bottom: 30px;

        h4{
            margin: 0;
        }

        a{
            display: block;
            margin-top: 10px;
            font-size: 1.5rem;

            &.router-link-active{
                color: #8b0000;
                font-weight: bold;
            }

            &:hover{
                color: #8b0000;
                cursor: pointer;
            }
        }

        p{
            opacity: 0.8;
            line-height: 16px;
            margin: 10px 0;
        }
    }
</style>

<style lang="scss">
.product-image {
    border-radius: 4px;
    box-shadow: 5px 5px 30px 0 rgba(0, 0, 0, 0.05);
}
</style>

<script>
    import Product from '../../components/elements/product'
    export default {
        data () {
            return {
                products: [
                    {
                        name: 'Stykgods / Partigods',
                        slug: 'stykgods'
                    },
                    {
                        name: 'Hellast / Full load',
                        slug: 'hellast'
                    },
                    {
                        name: 'Bulk',
                        slug: 'bulk'
                    },
                    {
                        name: 'Køl / Frys',
                        slug: 'koel-frys'
                    },
                    {
                        name: 'Farligt gods / ADR',
                        slug: 'farligt-gods'
                    },
                    {
                        name: 'Fragtfirma',
                        slug: 'fragtfirma'
                    }
                ]
            }
        },
        components: {
            'product': Product
        }
    }
</script>



// WEBPACK FOOTER //
// products.vue?01060e0a